import type React from 'react';
import type { ReactElement, ReactNode } from 'react';
import { Checkbox } from '@finn-no/troika-react-checkbox';

import type { ApiQueryParams, CheckboxTree, NestedFacet } from '../../../interfaces';

interface Props {
    facet: NestedFacet;
    ancestors: string[];
    checked: CheckboxTree;
    displayValue: (facet: NestedFacet) => string;
    sortChildren: (facet1: NestedFacet, facet2: NestedFacet) => number;
    checkboxClick: (path: string[]) => void;
    triggerFetch: (queryParams?: ApiQueryParams) => void;
}

export const ExpandableNestedCheckbox: React.FC<Props> = ({
    facet,
    ancestors,
    checked,
    displayValue,
    sortChildren,
    checkboxClick,
    triggerFetch,
}): ReactElement<Props> => {
    const onClick = (): void => {
        checkboxClick([...ancestors, facet.value]);
        triggerFetch();
    };

    const renderChildCheckbox = (child: NestedFacet): ReactNode => (
        <ExpandableNestedCheckbox
            key={child.value}
            facet={child}
            ancestors={[...ancestors, facet.value]}
            checked={checked[facet.value]}
            displayValue={displayValue}
            sortChildren={sortChildren}
            checkboxClick={checkboxClick}
            triggerFetch={triggerFetch}
        />
    );

    const disableCheckbox = facet.count === 0 && !checked[facet.value];
    const facetChildren = [...(facet.children || [])];

    return (
        <div>
            <Checkbox
                data-testid={`DestinationFilter-Checkbox-${facet.value.replace(' ', '_')}`}
                label={`${displayValue(facet)} (${facet.count})`}
                checked={!!checked[facet.value]}
                disabled={disableCheckbox}
                onChange={onClick}
            />
            {checked[facet.value] && <div className="u-ml16">{facetChildren.sort(sortChildren).map(renderChildCheckbox)}</div>}
        </div>
    );
};
